<template>
    <div>
        <PageHeader :page="page" :template="2" @action="createNew" v-if="!state.loading"/>
        <div class="content" v-if="!state.loading">
            <DataTable :tableData="tableData" @view="view" @edit="edit" @delete="deleteSchedule"/>
        </div>
        <div class="temp-row" v-if="state.loading" style="text-align: center;">
            <img src="@/assets/img/ajldr.gif" style="width:100px"/>
        </div>
    </div>

    <ModalView
        :isVisible="state.CreateModal"
        :fixclose="true"
        @close="state.CreateModal = false">
        
        <DynamicForm :columns="1"
        :fields="newFields" @submit="createSchedule"
        :submitting="state.submitting" :errors="state.errors"
        :success="state.success"/>
    </ModalView> 

    <ModalView
        :isVisible="state.viewModal"
        :fixclose="true"
        @close="state.viewModal = false">
        
        <FormView :columns="1"
        :fields="viewFields"/>
    </ModalView> 

    <ModalView
      :isVisible="state.editModal"
      :fixclose="true"
      @close="state.editModal = false">
      <div v-if="state.modalLoading" style="text-align: center;">
          <img src="@/assets/img/ajldr.gif" style="width:100px"/>
      </div>
      <div v-else>
        <DynamicForm :columns="1"
        :fields="editFields" @submit="createSchedule"
        :submitting="state.submitting" :errors="state.errors"
        :success="state.success"/>
      </div>
    </ModalView>
    
</template>
<script>
import icons from '@/assets/js/icons.js';
import { defineComponent, reactive, ref, onMounted} from 'vue';
import PageHeader from '@/components/PageHeader.vue';
import DataTable from '@/components/DataTable.vue';
import DynamicForm from '@/components/DynamicForm.vue';
import FormView from '@/components/FormView.vue';
import ModalView from '@/components/ModalView.vue';
import call from "../composables/call.js";
import { urls } from "../assets/js/urls";

export default defineComponent({
  components:{PageHeader, DataTable,DynamicForm,ModalView,FormView},
  setup(){
    const type=ref([]);
    const staff=ref([]);
    const viewFields=ref([]);
    const editFields=ref([]);
    const state=reactive({CreateModal:false, submitting:false,error:[],success:false,
      loading:false,ViewModal:false,viewModal:false,editModal:false,
      modalLoading:false,
      privacy:[{label:"Private",value:"private"},{label:"Office",value:"office"}]
    });
    const svgIcons = ref(icons);
    const page=ref({title:"Schedule List", btn:"",
    desc:"Manage your schedule in one page"})
    const tableData = ref({
      rows: [],
      loading: true,
      columns: [
        { label: "SN" },
        { label: "Title" },
        { label: "Date & Time" },
        { label: "Type" },
        { label: "Visibility" }
      ],
      options:{
        label:"Options",
        action_label:[icons.view,icons.edit,icons.trash],
        action:["view","edit","delete"]
      },
      total:0
    });
    
    const newFields=ref([
      { name: "Add Schedule", number: "1",data: 
        [{ type: 'text', name: 'title', label: 'Title',
          value: ""  },
          { type: 'textarea', name: 'desc', label: 'Description',
          value: ""  },
          {type:"select", name:"type", label:"Type", options:type},
          { type: 'datetime', name: 'start', label: 'Start Date & Time',
          value: ""  },
          { type: 'datetime', name: 'end', label: 'End Date & Time', desc:"If it lasts more than a day else leave empty",
          value: ""  },
          {type:"select", name:"privacy", label:"Visibility",
            options:state.privacy
          }
        ]
      },
      { name: "Assign Schedule", number: "2",data: 
        [{ type: 'checkbox', name: 'assignees', label: 'Staff',
          values:staff}
        ]
      }
    ])
    function createNew(){
      state.success=false;
      state.error=[]
      state.submitting=false;
      state.CreateModal=true;
    }

    function setTable(msg){
      var data={}
      tableData.value.loading = false;
      tableData.value.rows.length=0
      Object.keys(msg).forEach(set => {
        data={id:msg[set].id,desc:msg[set].desc,ass:msg[set].ass};
        var v=[];
        Object.keys(msg[set].val).forEach(row => {
          v.push(msg[set].val[row])
        });
        data.val=v;
        tableData.value.rows.push(data)
      });
      tableData.value.total=tableData.value.rows.length
    }

    onMounted(() => {
      call({
        url:urls.schedule,
        data:{startMySchedule:""},
        success:(res)=>{
          state.loading=false
          if(res.status){
            var d=res.msg;
            staff.value=[];
            Object.keys(d.staff).forEach(k => {
              staff.value.push(d.staff[k])
            })
            type.value=[];
            Object.keys(d.type).forEach(k => {
              type.value.push(d.type[k])
            })
            setTable(d.list);
            page.value.btn="Add schedule";
          }else{
            alert(res.msg);
          }
        }
      })
    });

    function createSchedule(data){
      state.submitting=true;
      state.errors=[];
      data.createSchedule="";
      call({
          url:urls.schedule,
          data:data,
          success:(res)=>{
            state.submitting=false;
            if(res.status){
              setTable(res.msg);
              state.success=true;
            }else{
                setErrors(res)
            }
          }
      })
    }

    function setErrors(res){
      var errors=[];
      Object.keys(res.msg).forEach(key => {
      var e=res.msg[key],er="";
      Object.keys(e).forEach(k => {
          er+=er=="" ? e[k] : ", "+e[k]
      })
      errors.push(er);
      });
      state.errors=errors;
    }

    function view(i){
        var data=tableData.value.rows[i],
        val=data.val;
        var date=val[2][0];
        if(Object.keys(val[2]).length > 1){
          date+="<br/> "+val[2][1];
        }
        viewFields.value=[
          { name: "Schedule Details", number: "1",data: 
            [{ name: 'title', label: 'Title',
              value: val[1]  },
              { name: 'desc', label: 'Description',
              value: data.desc },
              {name:"type", label:"Type", value:val[3]},
              { name: 'start', label: 'Date',
              value: date  },
              {name:"privacy", label:"Visibility",
                value:val[4]
              },
              {name:"assignees", label:"Assigned to",
                value:data.ass
              }
            ]
          }
        ]
        state.viewModal=true;
    }

    function edit(i){
      var data=tableData.value.rows[i];
      state.editModal=true;
      state.modalLoading=true;
      state.success=false;
      call({
        url:urls.schedule,
        data:{getSchedule:data.id},
        success:(res)=>{
          state.modalLoading=false
          if(res.status){
            var d=res.msg;
            staff.value=[];
            Object.keys(d.staff).forEach(k => {
              staff.value.push(d.staff[k])
            })
            var val=d.data;
            var ass=[];
            Object.keys(val.ass).forEach(k => {
              ass.push(val.ass[k])
            })
            editFields.value=[
              { name: "Edit Schedule", number: "1",data: 
                [{ type: 'text', name: 'title', label: 'Title',
                  value: val.title  },
                  { type: 'textarea', name: 'desc', label: 'Description',
                  value: val.desc  },
                  {type:"select", name:"type", label:"Type", options:type,value:val.type},
                  { type: 'datetime', name: 'start', label: 'Start Date & Time',
                  value: val.sdate  },
                  { type: 'datetime', name: 'end', label: 'End Date & Time', desc:"If it lasts more than a day else leave empty",
                  value: val.edate  },
                  {type:"select", name:"privacy", label:"Visibility",
                    options:state.privacy, value:val.privacy},
                  { type: 'hidden', name: 'id',
                  value: val.id  }
                ]
              },
              { name: "Assign Schedule", number: "2",data: 
                [{ type: 'checkbox', name: 'assignees', label: 'Staff',
                  values:staff, value:ass}
                ]
              }
            ]
          }else{
            alert(res.msg);
          }
        }
      })
    }

    function deleteSchedule(i){
        state.loading=true;
        var data=tableData.value.rows[i]
        call({
        url:urls.schedule,
        data:{deleteSchedule:data.id},
        success:(res)=>{
          state.loading=false
          if(res.status){
            setTable(res.msg);
          }else{
            alert(res.msg);
          }
        }
      })

    }


    return{page,icons: svgIcons.value,tableData,state,newFields,createNew,createSchedule,
    view,viewFields,edit,editFields,deleteSchedule
    }
  }
})

</script>  